import axios from 'axios';
import logCollector from '@/common/logCollector';

export default {
  /**
   * Load the application wide translations.
   */
  loadDefaultLanguage(lang) {
    return axios.get(`/app-language/${lang}`);
  },
  /**
   * Load preferred language keys, that is
   * if the user has previously set a language and it is stored in localStorage, load this language,
   * otherwise the default language is loaded.
   */
  loadLanguage(lang) {
    return axios.get(`/language/${lang}`);
  },
};
